import './styles/styles.css';
import { GameLoop } from './core/runtime/game-loop.js';

const loop = new GameLoop();

loop.start();
